import { __decorate } from 'tslib';
import { Component, EventEmitter, ChangeDetectorRef, Input, Output, ViewChild, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

const _c0 = ["*"];
const _c1 = ["modalRoot"];
const _c2 = ["modalContent"];
function ModalComponent_div_4_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 13);
    ɵngcc0.ɵɵlistener("click", function ModalComponent_div_4_div_2_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(2); return ctx_r7.close(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r3.cancelButtonLabel || "Close");
} }
function ModalComponent_div_4_h4_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "h4", 14);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r4.title);
} }
function ModalComponent_div_4_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 15);
    ɵngcc0.ɵɵlistener("click", function ModalComponent_div_4_div_9_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(2); return ctx_r9.close(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r5.cancelButtonLabel);
} }
function ModalComponent_div_4_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 16);
    ɵngcc0.ɵɵlistener("click", function ModalComponent_div_4_div_10_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(2); return ctx_r11.onSubmit.emit(undefined); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r6.submitButtonLabel);
} }
function ModalComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵelementStart(1, "div", 6);
    ɵngcc0.ɵɵtemplate(2, ModalComponent_div_4_div_2_Template, 1, 1, "div", 7);
    ɵngcc0.ɵɵtemplate(3, ModalComponent_div_4_h4_3_Template, 2, 1, "h4", 8);
    ɵngcc0.ɵɵprojection(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 9);
    ɵngcc0.ɵɵprojection(6, 1);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 10);
    ɵngcc0.ɵɵprojection(8, 2);
    ɵngcc0.ɵɵtemplate(9, ModalComponent_div_4_div_9_Template, 2, 1, "div", 11);
    ɵngcc0.ɵɵtemplate(10, ModalComponent_div_4_div_10_Template, 2, 1, "div", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("top", ctx_r2.mode === "popup" ? "calc(" + ctx_r2.contentTop + ")" : null);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r2.headerClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r2.hideCloseButton);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.title);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r2.footerClass);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.cancelButtonLabel);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.submitButtonLabel);
} }
const _c3 = [[["modal-header"]], [["modal-content"]], [["modal-footer"]]];
const _c4 = function (a0, a1, a2) { return { "in": a0, "fade": a1, "Modal--popup": a2 }; };
const _c5 = ["modal-header", "modal-content", "modal-footer"];
let ModalHeaderComponent = class ModalHeaderComponent {
};
ModalHeaderComponent.ɵfac = function ModalHeaderComponent_Factory(t) { return new (t || ModalHeaderComponent)(); };
ModalHeaderComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ModalHeaderComponent, selectors: [["modal-header"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function ModalHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
let ModalContentComponent = class ModalContentComponent {
};
ModalContentComponent.ɵfac = function ModalContentComponent_Factory(t) { return new (t || ModalContentComponent)(); };
ModalContentComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ModalContentComponent, selectors: [["modal-content"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function ModalContentComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
let ModalFooterComponent = class ModalFooterComponent {
};
ModalFooterComponent.ɵfac = function ModalFooterComponent_Factory(t) { return new (t || ModalFooterComponent)(); };
ModalFooterComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ModalFooterComponent, selectors: [["modal-footer"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function ModalFooterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
let ModalComponent = class ModalComponent {
    // -------------------------------------------------------------------------
    // Constructor
    // -------------------------------------------------------------------------
    constructor(changeDetectorRef) {
        this.changeDetectorRef = changeDetectorRef;
        this.closeOnEscape = true;
        this.closeOnOutsideClick = true;
        this.hideCloseButton = false;
        this.animateBackdrop = true;
        this.animationTiming = 300;
        this.backdropColor = '#000000';
        this.backdropOpacity = 0.6;
        this.mode = 'popup';
        this.contentTop = "310px";
        // -------------------------------------------------------------------------
        // Outputs
        // -------------------------------------------------------------------------
        this.onOpen = new EventEmitter(false);
        this.onClose = new EventEmitter(false);
        this.onSubmit = new EventEmitter(false);
        // -------------------------------------------------------------------------
        // Public properties
        // -------------------------------------------------------------------------
        this.isOpened = false;
        this.styleTransforms = {};
        this.createBackDrop();
    }
    // -------------------------------------------------------------------------
    // Lifecycle Methods
    // -------------------------------------------------------------------------
    ngOnDestroy() {
        document.body.className = document.body.className.replace(/modal-open\b/, '');
        if (this.backdropElement && this.backdropElement.parentNode === this.getBackdropParent()) {
            if (this.animateBackdrop) {
                const convertedBackdropColor = this.hexToRgb(this.backdropColor);
                this.backdropElement.style.backgroundColor = `rgba(${convertedBackdropColor.r}, ${convertedBackdropColor.g}, ${convertedBackdropColor.b}, 0)`;
                setTimeout(() => {
                    this.getBackdropParent().removeChild(this.backdropElement);
                }, this.animationTiming);
            }
            else {
                this.getBackdropParent().removeChild(this.backdropElement);
            }
        }
    }
    ngAfterViewInit() {
        if (this.mode === 'slideIn' && this.isOpened === false) {
            this.styleTransforms = { 'transform': `translateY(${this.contentEl.nativeElement.getBoundingClientRect().height}px)` };
            this.changeDetectorRef.detectChanges();
        }
    }
    // -------------------------------------------------------------------------
    // Public Methods
    // -------------------------------------------------------------------------
    open(...args) {
        if (this.isOpened) {
            return;
        }
        this.isOpened = true;
        this.onOpen.emit(args);
        if (this.animateBackdrop) {
            const convertedBackdropColor = this.hexToRgb(this.backdropColor);
            this.getBackdropParent().appendChild(this.backdropElement);
            // tiny timeout to allow transition to catch up...
            setTimeout(() => {
                this.backdropElement.style.backgroundColor = `rgba(${convertedBackdropColor.r}, ${convertedBackdropColor.g}, ${convertedBackdropColor.b}, ${this.backdropOpacity})`;
                ;
            });
        }
        else {
            this.getBackdropParent().appendChild(this.backdropElement);
        }
        // not sure what this was for
        // window.setTimeout(() => this.modalRoot.nativeElement.focus(), 0);
        document.body.className += ' Modal--open';
        this.styleTransforms = { 'transition': `transform ${this.animationTiming}ms`, 'transform': `translateY(0)` };
        this.changeDetectorRef.detectChanges();
    }
    close(...args) {
        if (!this.isOpened) {
            return;
        }
        this.isOpened = false;
        this.onClose.emit(args);
        if (this.animateBackdrop) {
            const convertedBackdropColor = this.hexToRgb(this.backdropColor);
            this.backdropElement.style.backgroundColor = `rgba(${convertedBackdropColor.r}, ${convertedBackdropColor.g}, ${convertedBackdropColor.b}, 0)`;
            setTimeout(() => {
                this.getBackdropParent().removeChild(this.backdropElement);
            }, this.animationTiming);
        }
        else {
            this.getBackdropParent().removeChild(this.backdropElement);
        }
        document.body.className = document.body.className.replace(/Modal--open\b/, '');
        this.styleTransforms = { 'transition': `transform ${this.animationTiming}ms`, 'transform': `translateY(${this.contentEl.nativeElement.getBoundingClientRect().height}px)` };
        this.changeDetectorRef.detectChanges();
    }
    // -------------------------------------------------------------------------
    // Private Methods
    // -------------------------------------------------------------------------
    hexToRgb(hex) {
        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : undefined;
    }
    createBackDrop() {
        this.backdropElement = document.createElement('div');
        const convertedBackdropColor = this.hexToRgb(this.backdropColor);
        if (this.animateBackdrop) {
            this.backdropElement.style.transition = `background-color ${this.animationTiming}ms`;
        }
        this.backdropElement.style.backgroundColor = `rgba(${convertedBackdropColor.r}, ${convertedBackdropColor.g}, ${convertedBackdropColor.b}, 0)`;
        this.backdropElement.classList.add('Modal__backdrop');
        this.backdropElement.addEventListener('click', () => {
            if (this.closeOnOutsideClick) {
                this.close();
            }
        });
    }
    getBackdropParent() {
        let parentForBackdrop;
        if (this.backdropParentSelector) {
            parentForBackdrop = document.querySelector(this.backdropParentSelector);
        }
        else {
            parentForBackdrop = document.body;
        }
        return parentForBackdrop;
    }
};
ModalComponent.ɵfac = function ModalComponent_Factory(t) { return new (t || ModalComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
ModalComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ModalComponent, selectors: [["modal"]], viewQuery: function ModalComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c1, 1);
        ɵngcc0.ɵɵviewQuery(_c2, 1);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.modalRoot = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.contentEl = _t.first);
    } }, inputs: { closeOnEscape: "closeOnEscape", closeOnOutsideClick: "closeOnOutsideClick", hideCloseButton: "hideCloseButton", animateBackdrop: "animateBackdrop", animationTiming: "animationTiming", backdropColor: "backdropColor", backdropOpacity: "backdropOpacity", mode: "mode", contentTop: "contentTop", modalClass: "modalClass", headerClass: "headerClass", footerClass: "footerClass", title: "title", cancelButtonLabel: "cancelButtonLabel", submitButtonLabel: "submitButtonLabel", backdropParentSelector: "backdropParentSelector" }, outputs: { onOpen: "onOpen", onClose: "onClose", onSubmit: "onSubmit" }, ngContentSelectors: _c5, decls: 5, vars: 8, consts: [["tabindex", "-1", "role", "dialog", 1, "Modal", 3, "ngClass", "ngStyle"], ["modalRoot", ""], [1, "ModalDialog", 3, "ngClass"], ["modalContent", ""], ["class", "ModalDialogContent", 3, "top", 4, "ngIf"], [1, "ModalDialogContent"], [1, "ModalDialogContentHeader", 3, "ngClass"], ["role", "button", "class", "ModalDialogContentHeader__button icon-close", 3, "click", 4, "ngIf"], ["class", "ModalDialogContentHeader__title", 4, "ngIf"], [1, "ModalDialogContentBody"], [1, "ModalDialogContentFooter", 3, "ngClass"], ["role", "button", "class", "ModalDialogContentFooter__button", "data-dismiss", "modal", 3, "click", 4, "ngIf"], ["role", "button", "class", "ModalDialogContentFooter__button", 3, "click", 4, "ngIf"], ["role", "button", 1, "ModalDialogContentHeader__button", "icon-close", 3, "click"], [1, "ModalDialogContentHeader__title"], ["role", "button", "data-dismiss", "modal", 1, "ModalDialogContentFooter__button", 3, "click"], ["role", "button", 1, "ModalDialogContentFooter__button", 3, "click"]], template: function ModalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c3);
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2, 3);
        ɵngcc0.ɵɵtemplate(4, ModalComponent_div_4_Template, 11, 8, "div", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction3(4, _c4, ctx.isOpened, ctx.isOpened, ctx.mode === "popup"))("ngStyle", ctx.styleTransforms);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ctx.modalClass);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isOpened || ctx.mode === "slideIn");
    } }, directives: [ɵngcc1.NgClass, ɵngcc1.NgStyle, ɵngcc1.NgIf], encapsulation: 2 });
ModalComponent.ctorParameters = () => [
    { type: ChangeDetectorRef }
];
__decorate([
    Input()
], ModalComponent.prototype, "modalClass", void 0);
__decorate([
    Input()
], ModalComponent.prototype, "headerClass", void 0);
__decorate([
    Input()
], ModalComponent.prototype, "footerClass", void 0);
__decorate([
    Input()
], ModalComponent.prototype, "closeOnEscape", void 0);
__decorate([
    Input()
], ModalComponent.prototype, "closeOnOutsideClick", void 0);
__decorate([
    Input()
], ModalComponent.prototype, "title", void 0);
__decorate([
    Input()
], ModalComponent.prototype, "hideCloseButton", void 0);
__decorate([
    Input()
], ModalComponent.prototype, "cancelButtonLabel", void 0);
__decorate([
    Input()
], ModalComponent.prototype, "submitButtonLabel", void 0);
__decorate([
    Input()
], ModalComponent.prototype, "backdropParentSelector", void 0);
__decorate([
    Input()
], ModalComponent.prototype, "animateBackdrop", void 0);
__decorate([
    Input()
], ModalComponent.prototype, "animationTiming", void 0);
__decorate([
    Input()
], ModalComponent.prototype, "backdropColor", void 0);
__decorate([
    Input()
], ModalComponent.prototype, "backdropOpacity", void 0);
__decorate([
    Input()
], ModalComponent.prototype, "mode", void 0);
__decorate([
    Input()
], ModalComponent.prototype, "contentTop", void 0);
__decorate([
    Output()
], ModalComponent.prototype, "onOpen", void 0);
__decorate([
    Output()
], ModalComponent.prototype, "onClose", void 0);
__decorate([
    Output()
], ModalComponent.prototype, "onSubmit", void 0);
__decorate([
    ViewChild('modalRoot', { static: false })
], ModalComponent.prototype, "modalRoot", void 0);
__decorate([
    ViewChild('modalContent', { static: false })
], ModalComponent.prototype, "contentEl", void 0);

let ModalModule = class ModalModule {
};
ModalModule.ɵfac = function ModalModule_Factory(t) { return new (t || ModalModule)(); };
ModalModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: ModalModule });
ModalModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ModalHeaderComponent, [{
        type: Component,
        args: [{
                selector: 'modal-header',
                template: `
        <ng-content></ng-content>`
            }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ModalContentComponent, [{
        type: Component,
        args: [{
                selector: 'modal-content',
                template: `
        <ng-content></ng-content>`
            }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ModalFooterComponent, [{
        type: Component,
        args: [{
                selector: 'modal-footer',
                template: `
        <ng-content></ng-content>`
            }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ModalComponent, [{
        type: Component,
        args: [{
                selector: 'modal',
                template: `
        <div class="Modal"
             tabindex="-1"
             role="dialog"
             #modalRoot
             [ngClass]="{ 'in': isOpened, 'fade': isOpened , 'Modal--popup': mode === 'popup'}"
             [ngStyle]="styleTransforms">
            <div class="ModalDialog" [ngClass]="modalClass" #modalContent>
                <div class="ModalDialogContent" *ngIf="isOpened || mode === 'slideIn'" [style.top]="mode === 'popup' ? 'calc(' + contentTop + ')' : null">
                    <div class="ModalDialogContentHeader" [ngClass]="headerClass">
						<div *ngIf="!hideCloseButton"
							role="button"
							class="ModalDialogContentHeader__button icon-close"
							[attr.aria-label]="cancelButtonLabel || 'Close'" (click)="close()">
						</div>
                        <h4 class="ModalDialogContentHeader__title" *ngIf="title">{{ title }}</h4>
                        <ng-content select="modal-header"></ng-content>
                    </div>
                    <div class="ModalDialogContentBody">
                        <ng-content select="modal-content"></ng-content>
                    </div>
                    <div class="ModalDialogContentFooter" [ngClass]="footerClass">
                        <ng-content select="modal-footer"></ng-content>
                        <div *ngIf="cancelButtonLabel" role="button" class="ModalDialogContentFooter__button" data-dismiss="modal" (click)="close()">{{ cancelButtonLabel }}</div>
                        <div *ngIf="submitButtonLabel" role="button" class="ModalDialogContentFooter__button" (click)="onSubmit.emit(undefined)">{{ submitButtonLabel }}</div>
                    </div>
                </div>
            </div>
        </div>
	`
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }]; }, { closeOnEscape: [{
            type: Input
        }], closeOnOutsideClick: [{
            type: Input
        }], hideCloseButton: [{
            type: Input
        }], animateBackdrop: [{
            type: Input
        }], animationTiming: [{
            type: Input
        }], backdropColor: [{
            type: Input
        }], backdropOpacity: [{
            type: Input
        }], mode: [{
            type: Input
        }], contentTop: [{
            type: Input
        }], onOpen: [{
            type: Output
        }], onClose: [{
            type: Output
        }], onSubmit: [{
            type: Output
        }], modalClass: [{
            type: Input
        }], headerClass: [{
            type: Input
        }], footerClass: [{
            type: Input
        }], title: [{
            type: Input
        }], cancelButtonLabel: [{
            type: Input
        }], submitButtonLabel: [{
            type: Input
        }], backdropParentSelector: [{
            type: Input
        }], modalRoot: [{
            type: ViewChild,
            args: ['modalRoot', { static: false }]
        }], contentEl: [{
            type: ViewChild,
            args: ['modalContent', { static: false }]
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ModalModule, { declarations: function () { return [ModalComponent, ModalHeaderComponent, ModalContentComponent, ModalFooterComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [ModalComponent, ModalHeaderComponent, ModalContentComponent, ModalFooterComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ModalModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    ModalComponent,
                    ModalHeaderComponent,
                    ModalContentComponent,
                    ModalFooterComponent
                ],
                exports: [
                    ModalComponent,
                    ModalHeaderComponent,
                    ModalContentComponent,
                    ModalFooterComponent
                ]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { ModalComponent, ModalContentComponent, ModalFooterComponent, ModalHeaderComponent, ModalModule };

//# sourceMappingURL=projektionisten-ngx-modal.js.map